import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header d-flex align-items-center" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table table-tenant-sm table-hover" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import {
  EventPartyStatusTypes,
  EventPartyStatusTypeOptions,
} from "@/core/types/shop/ShopCustomerTypes";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import EventsServices from "../services/EventsServices";
import UserDetails from "@/projects/tenant/components/UserDetails.vue";
import AdjustPoints from "../components/shop/ShopCustomer/AdjustPoints.vue";
import UserDetailCustomer from "../components/shop/UserDetailShop.vue";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopCustomer',
  setup(__props) {

const t = i18n.global.t;
const isLoading = ref(false);
const data = ref(<any>[]);
const criteria = ref<any>({
  page: 1,
  pageSize: 25,
  status: EventPartyStatusTypes.Applied,
});
const UserDetailsRef = ref<InstanceType<typeof UserDetails>>();
const AdjustPointsRef = ref<any>(null);
const userDetailShopRef = ref<any>(null);
const tab = ref<any>(EventPartyStatusTypes.Applied);
const accountSelected = ref(0);
const isTabActive = (_tab: any) => {
  return tab.value === _tab;
};

const reset = () => {
  criteria.value.email = null;
  fetchData(1);
};

const changeTab = (_value: any) => {
  tab.value = _value;
  criteria.value.status = tab.value;
  if (tab.value === 5) {
    criteria.value.status = null;
  }
  fetchData(1);
};

const getStatusLabel = (value: number) => {
  const option = EventPartyStatusTypeOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventsServices.queryCustomerList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);
const showUserDetails = (partyId: number) => {
  UserDetailsRef.value?.show(partyId);
};

const showUserDetailShop = (item) => {
  userDetailShopRef.value?.show(item.partyId);
};

const showAdjustPoints = (item) => {
  AdjustPointsRef.value?.show(item);
};

const openConfirmPanel = (_action: EventPartyStatusTypes, id: number) => {
  openConfirmModal?.(() => {
    return {
      [EventPartyStatusTypes.Approved]: () =>
        EventsServices.approveCustomerById(id),
      [EventPartyStatusTypes.Rejected]: () =>
        EventsServices.rejectCustomerById(id),
      [EventPartyStatusTypes.Cancelled]: () =>
        EventsServices.cancelCustomerById(id),
    }
      [_action]()
      .then(() => {
        fetchData(criteria.value.page);
      });
  });
};

function getStatusTag(status: EventPartyStatusTypes) {
  switch (status) {
    case EventPartyStatusTypes.Applied:
      return "";
    case EventPartyStatusTypes.Approved:
      return "success";
    case EventPartyStatusTypes.Rejected:
      return "danger";
    case EventPartyStatusTypes.Cancelled:
      return "warning";
  }
}

function getButtonConfigs(item) {
  let configs: any[] = [];
  switch (item.status) {
    case EventPartyStatusTypes.Applied:
      configs.push(
        {
          label: t("action.approve"),
          type: "success",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Approved, item.id),
        },
        {
          label: t("action.reject"),
          type: "danger",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Rejected, item.id),
        }
      );
      break;

    case EventPartyStatusTypes.Approved:
      configs.push(
        {
          label: t("title.adjustPoints"),
          type: "primary",
          action: () => showAdjustPoints(item),
        },
        {
          label: t("fields.userShopDetail"),
          type: "info",
          action: () => showUserDetailShop(item),
        }
      );
      break;

    case EventPartyStatusTypes.Rejected:
      configs.push(
        {
          label: t("action.approve"),
          type: "success",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Approved, item.id),
        },
        {
          label: t("action.cancel"),
          type: "warning",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Cancelled, item.id),
        }
      );
      break;
    case EventPartyStatusTypes.Cancelled:
      configs.push(
        {
          label: t("action.approve"),
          type: "success",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Approved, item.id),
        },
        {
          label: t("action.reject"),
          type: "danger",
          action: () =>
            openConfirmPanel(EventPartyStatusTypes.Rejected, item.id),
        }
      );
      break;
  }
  return configs;
}

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventPartyStatusTypeOptions), (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: tab.value
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-2", [
          { active: isTabActive(tab.value) },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (changeTab(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            class: "w-200px",
            modelValue: criteria.value.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.email) = $event)),
            disabled: isLoading.value,
            clearable: "",
            placeholder: _ctx.$t('title.email'),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue", "disabled", "placeholder"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
            loading: isLoading.value,
            class: "ms-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: reset,
            class: "ms-2",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.eventKey")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.points")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_UserInfo, {
                          email: item.email,
                          name: item.nativeName,
                          partyId: item.partyId,
                          class: "me-2"
                        }, null, 8, ["email", "name", "partyId"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.eventKey), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.totalPoint
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.lastOperatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getButtonConfigs(item), (button, index) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            key: index,
                            type: button.type,
                            size: "small",
                            onClick: button.action
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(button.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "onClick"]))
                        }), 128))
                      ])
                    ], 10, _hoisted_11))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(UserDetails, {
      ref_key: "UserDetailsRef",
      ref: UserDetailsRef
    }, null, 512),
    _createVNode(AdjustPoints, {
      ref_key: "AdjustPointsRef",
      ref: AdjustPointsRef,
      onUpdate: _cache[3] || (_cache[3] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(UserDetailCustomer, {
      ref_key: "userDetailShopRef",
      ref: userDetailShopRef
    }, null, 512)
  ], 64))
}
}

})